<template>
  <v-dialog
    width="800"
    persistent
    v-model="dialog"
  >
    <v-form @submit.prevent.stop="$canWrite && (submit())">
      <v-card>
        <v-card-title>
          Nouveau tag
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" v-if="!isSubmitting">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <v-row justify="center" align="center">
            <v-col cols="3">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="color"
                    v-bind="attrs"
                    v-on="on"
                    x-large
                    style="width: 100%;"
                  >
                    &nbsp;
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(color, index) in colors"
                    :key="index"
                  >
                    <v-btn
                      :color="color"
                      @click="selectColor(color)"
                      style="width: 100%;"
                    >
                      &nbsp;
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field v-model="label" label="Nom du tag*" outlined hide-details required autofocus />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" v-if="!isSubmitting">Annuler</v-btn>
          <v-btn :disabled="!$canWrite" color="primary darken-1" :loading="isSubmitting" type="submit" depressed>Créer ce tag</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    clientId: {
      type: Number,
      required: false,
    },
    makerId: {
      type: Number,
      required: false,
    },
    defaultLabel: {
      type: String,
      default: ``,
    },
  },

  data: () => ({
    isOpened: true,
    label: ``,
    color: ``,
    errors: [],
    isSubmitting: false,
  }),

  computed: {
    dialog: {
      get() { return this.isOpened; },
      set(isOpened) {
        this.isOpened = isOpened;
        if (!isOpened) {
          this.$emit(`close`);
        }
      },
    },
    ...mapState(`model/tag`, [`colors`]),
  },

  methods: {
    selectColor(color) {
      this.color = color;
    },
    async submit() {
      this.errors = [];
      if (!_.trim(this.label)) { this.errors.push(`Le nom du tag est obligatoire`); }

      if (this.errors.length) { return; }

      this.isSubmitting = true;
      const tagParams = {
        label: this.label,
        color: this.color,
      };
      let tag = null;
      if (this.makerId) {
        tag = await this.$store.dispatch(`ui/tagsCreateDialog/addTagForMaker`, {
          ...tagParams,
          makerId: this.makerId,
        });
      } else if (this.clientId) {
        tag = await this.$store.dispatch(`ui/tagsCreateDialog/addTagForClient`, {
          ...tagParams,
          clientId: this.clientId,
        });
      } else {
        tag = await this.$store.dispatch(`ui/tagsCreateDialog/addTag`, tagParams);
      }
      this.isSubmitting = false;

      if (tag) {
        this.$emit(`created`, tag);
        this.$emit(`close`);
      } else {
        this.errors.push(`Impossible de créer ce tag, réessayez`);
      }
    },
  },

  watch: {
    defaultLabel(defaultLabel) {
      this.label = defaultLabel;
    },
  },

  beforeMount() {
    this.color = this.colors[_.random(this.colors.length - 1)];
    this.label = this.defaultLabel;
  },
};
</script>

<style lang="scss">
</style>
